import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
// import required modules
import { Pagination, Navigation } from "swiper/modules";

import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Home() {

  const [loading, setLoading] = useState(false);

  return (
    <div className="slider-wrapper">
      <div className="container">
        <Loader visible={loading} />
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar setLoading={setLoading} />
                </div>

                <div className="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div id="header">
                    <Swiper
                      pagination={{ clickable: true }}
                      modules={[Pagination]}
                      className="mySwiper"
                    >
                      <SwiperSlide>
                        <div className="swiper-wrapper">
                          {" "}
                          <div className="swiper-slide">
                            <img
                              src="images/idpl-slide6.jpg"
                              className="img-responsive"
                              title=""
                            />{" "}
                          </div>{" "}
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div>
                          {" "}
                          <div className="swiper-slide">
                            <img
                              src="images/idpl-slide1.jpg"
                              className="img-responsive"
                              alt=""
                              title=""
                            />{" "}
                          </div>{" "}
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div>
                          {" "}
                          <div className="swiper-slide">
                            <img
                              src="images/idpl-slide2.jpg"
                              className="img-responsive"
                              title=""
                            />
                          </div>{" "}
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div>
                          {" "}
                          <div className="swiper-slide">
                            <img
                              src="images/idpl-slide3.jpg"
                              className="img-responsive"
                              title=""
                            />{" "}
                          </div>{" "}
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>

                  {/* <div className="row mt20">
                    <div className="col-sm-4">
                      <div className="mini_img">
                        <img
                          src="images/minister/modi.jpg"
                          className="img-responsive"
                        />
                      </div>

                      <div className="min_cont">
                        <p
                          style={{
                            margin: "5px 13px",
                            textAlign: "left",
                            fontSize: "12px",
                          }}
                        >
                          <strong>Shri Narendra Modi</strong>
                          <br /> Hon'ble Prime Minister of India
                        </p>
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="mini_img ">
                        <Link to="/shri-mansukh-mandaviya">
                          <img
                            src="images/minister/manshukh.jpg"
                            className="img-responsive"
                          />
                        </Link>
                      </div>

                      <div className="min_cont">
                        <p
                          style={{
                            margin: "5px 13px",
                            textAlign: "left",
                            fontSize: "12px",
                          }}
                        >
                          <Link
                            to="/shri-mansukh-mandaviya"
                            style={{ textDecoration: "none !important" }}
                          >
                            <strong>Dr. Mansukh Mandaviya</strong>
                          </Link>
                          <br /> Hon'ble Minister (C&F)
                        </p>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="mini_img">
                        <img
                          src="images/minister/shri-bhagwanth-khuba.jpg"
                          className="img-responsive"
                        />
                      </div>

                      <div className="min_cont">
                        <p
                          style={{
                            margin: "5px 13px",
                            textAlign: "left",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                        >
                          <strong>Shri Bhagwanth Khuba</strong>
                          <br />
                          Hon'ble Minister of State (C&F)
                        </p>
                      </div>
                    </div>
                  </div> */}

                  <div className="row mt20 mb30 list-row">
                    <div className="col-sm-6">
                      <div className="pr5">
                        <div className="panel-group" id="accordion1">
                          <div className="panel panel-default para-list">
                            <div className="panel-heading">
                              <h4
                                className="panel-title"
                                style={{
                                  color: "#B70F0F",
                                  fontSize: "14px",
                                }}
                              >
                                SWACHH BHARAT ABHIYAN
                              </h4>
                            </div>

                            <p
                              style={{
                                margin: "5px 13px",
                                fontSize: "12px",
                              }}
                            >
                              "A message from Minister (C & F)" "All donations
                              towards the Prime Minister's National relief Fund
                              (PMNRF) are notified for 100% deduction from
                              taxable income under Section 80G of the Income Tax
                              Act, 1961."
                              <ul>
                                <li>
                                  <a
                                    target="_blank"
                                    href="pdf/MESSAGE_HMCF.pdf"
                                  >
                                    <b>
                                    Message from Honorable Minister on Swachhata Pakhwada During 1-15 September 2024.
                                    </b>
                                  </a>
                                </li>

                                <li>
                                  <a target="_blank" href="pdf/Message-of-MoS_CF.pdf">
                                    <b>
                                    Message from Honorable Minister of State on Swachhata Pakhwada During 1-15 September 2024.
                                    </b>
                                  </a>
                                </li>
                              </ul>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="pr5">
                        <div className="panel-group" id="accordion1">
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <h4
                                className="panel-title"
                                style={{ color: "#B70F0F", fontSize: "14px" }}
                              >
                                Pharma Formulations for Trade Sales
                              </h4>
                            </div>

                            <p style={{ margin: "5px 13px", fontSize: "12px" }}>
                              Earlier, IDPL was a well known name in Trade Sales
                              of Pharmaceutical Formulations. IDPL is going to
                              be re-launched into Trade Sales by engaging
                              franchisees. About 50 formulations, which include
                              its products latest prescription molecules in
                              Injectable, Oral and Topical..
                            </p>

                            <p style={{ margin: "9px 13px", fontSize: "12px" }}>
                              <a
                                href="#"
                                className="readmore"
                                target="_blank"
                                style={{ color: "#FFF" }}
                              >
                                Read More
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mt20 mb30">
                    <div className="col-sm-6">
                      <div className="pr5">
                        <div className="panel-group" id="accordion1">
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <h4
                                className="panel-title"
                                style={{ color: "#B70F0F", fontSize: "14px" }}
                              >
                                National Health Program{" "}
                              </h4>
                            </div>

                            <p style={{ margin: "5px 13px", fontSize: "12px" }}>
                              IDPL played a major role in the strategic National
                              Health Programmes like Family Welfare Programme &
                              Population Control (Mala - D & Mala - N)
                              anti-malarials (Chloroquine) and prevention of
                              dehydration (ORS) and provided quality medicines
                              to combat Plague in 1994 and also at the time of
                              natural calamities, floods etc.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="pr5">
                        <div className="panel-group" id="accordion1">
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <h4
                                className="panel-title"
                                style={{ color: "#B70F0F", fontSize: "14px" }}
                              >
                                Collaboration
                              </h4>
                            </div>

                            <p style={{ margin: "5px 13px", fontSize: "12px" }}>
                              IDPL is interested to have collabotations with
                              prestigious Institutes / Research / Pharmaceutical
                              Companies / Medical Colleges / Hospitals etc. in
                              the area of pharma research, drug discovery,
                              pre-clinical & clinical trials, biotechnology,
                              medical tourism, food fortification and other
                              areas of mutual interest.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
